import { render, staticRenderFns } from "./bigOpenVip.vue?vue&type=template&id=27562126&"
import script from "./bigOpenVip.vue?vue&type=script&lang=js&"
export * from "./bigOpenVip.vue?vue&type=script&lang=js&"
import style0 from "./bigOpenVip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports